export enum SmartBuildJob {
  FirstChoiceMetalsJob = 'first-choice-metals-job',
}
